import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[appScrollIntoView]'
})
export class ScrollIntoViewDirective implements OnChanges {
  @Input() appScrollIntoView: boolean;
  private scrollSubject = new Subject<void>();

  constructor(private el: ElementRef) {
    // Debounce the scroll action
    this.scrollSubject.pipe(debounceTime(300)) // 300ms debounce time
      .subscribe(() => {
        this.el.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'start'
        });
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appScrollIntoView'].currentValue) {
      this.scrollSubject.next();
    }
  }
}
